import { ADMIN_MESSAGE_FORMATS } from '../../../../constants/messageFormats';

export const CHAT_BUBBLE_MEDIA_CLASS = 'chat-bubble--media';
export const CHAT_BUBBLE_IMAGE_CLASS = 'chat-bubble--image';
export const CHAT_BUBBLE_FILE_CLASS = 'chat-bubble--file';

const normalizeClassName = (value) =>
  String(value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

export function getBubbleFormatMarkerClasses(messageFormat) {
  if (messageFormat === ADMIN_MESSAGE_FORMATS.IMAGE) {
    return [CHAT_BUBBLE_MEDIA_CLASS, CHAT_BUBBLE_IMAGE_CLASS];
  }

  if (messageFormat === ADMIN_MESSAGE_FORMATS.FILE) {
    return [CHAT_BUBBLE_MEDIA_CLASS, CHAT_BUBBLE_FILE_CLASS];
  }

  return [];
}

export function appendBubbleFormatClassName(baseClassName, messageFormat) {
  const merged = [
    ...normalizeClassName(baseClassName),
    ...getBubbleFormatMarkerClasses(messageFormat),
  ];

  return Array.from(new Set(merged)).join(' ');
}
